<template>
  <div>
    <ListagemPerfilMenuComponent />
  </div>
</template>

<script>

import ListagemPerfilMenuComponent from '../components/ListagemPerfilMenuComponent.vue';

export default {
  components: { ListagemPerfilMenuComponent },
  name: 'PerfilMenuPage'
}
</script>
